import { AppQueryParamsConfigMap } from './../app/constants';
import { useHistory } from 'react-router';
import { useQueryParams } from 'use-query-params';

export default function useChangeLocationSearch() {
  const history = useHistory();
  const [query] = useQueryParams(AppQueryParamsConfigMap);

  return (
    items: {
      param: keyof typeof query;
      value: string | undefined;
    }[],
  ) => {
    let queryStr = history.location.search.replace('?', '');

    items.forEach((item) => {
      const queryParamStr = `${item.param}=${item.value}`;

      queryStr = queryStr
        .split('&')
        .filter((q) => !q.includes(`${item.param}=`))
        .concat(item.value ? [queryParamStr] : [])
        .join('&');
    });

    return '?' + queryStr;
  };
}
